import * as _ from "lodash";

function getCouponRulePosition(couponRule: any): number {
  const rawPosition = couponRule && couponRule.position;
  const hasNumericPositionType =
    typeof rawPosition === "number" ||
    (typeof rawPosition === "string" && rawPosition.trim() !== "");
  const position = hasNumericPositionType
    ? Number(rawPosition)
    : Number.NaN;

  return Number.isInteger(position) && position >= 0
    ? position
    : Number.POSITIVE_INFINITY;
}

export function orderCouponRulesByPosition(couponRules: any): any[] {
  if (!_.isArray(couponRules)) {
    return [];
  }

  return _.orderBy(
    _.cloneDeep(couponRules),
    [getCouponRulePosition],
    ["asc"]
  );
}
